// Work Orders searches: the work order list (searchCall), the Operations tab (searchJobs and its
// filter buttons) and the Closed tab (searchClosedJobs, and closedJobList, the full Closed list).
// Moved out of app.js unchanged (docs/split-plan.md, session 7c).
import throttle from 'lodash/throttle';
import { getDB } from './utilities';
import { billingJobsActive, billingWorkOrdersActive, closedJobsActive, closedWorkOrdersActive } from './woFilters';

let shell = null;
export function setWoSearchDeps(deps) { shell = deps; }

// 'input', not keyup: the box's × clear button and pasting don't fire keyup.
document.getElementById('job-search').addEventListener('input', searchJobs);

document.getElementById('closed-search').addEventListener('input', searchClosedJobs);

var selectedButtons = {};

export function searchCall() {
  const searchQuery = document.getElementById('search').value.trim().toLowerCase();
  const searchTerms = searchQuery.split(/\s+/).filter(term => term.length > 0);
  let allJobs;
  
  if (billingWorkOrdersActive) {
    allJobs = document.querySelectorAll('.table-item.complete-job');
  } else if (closedWorkOrdersActive) {
    allJobs = document.querySelectorAll('.table-item.closed-job');
  } else {
    // Closed and Ready to Bill WOs belong only to their own filters: the inline
    // 'flex' below would otherwise override the stylesheet rule that hides them
    // (typing then clearing a search left every Ready to Bill WO showing in All).
    allJobs = document.querySelectorAll('.table-item:not(.closed-job):not(.complete-job)');
  }

  const allJobsArray = Array.from(allJobs);

  document.querySelectorAll('.table-item').forEach(job => {
    job.style.display = 'none';
  });

  allJobsArray.forEach(job => {

    if (job.classList.contains('filtered')) {
      return;
    }

    let jobMatchFound = false;

    if (searchTerms.length === 0) {
      jobMatchFound = true;
    } else {
    
      try {
        const jobData = JSON.parse(job.getAttribute('data-jobinfo'));
        if (jobData) {
          delete jobData.Notes;
          jobMatchFound = searchTerms.every(term =>
            JSON.stringify(jobData).toLowerCase().includes(term)
          );
        } else {
          console.error('Missing or invalid data-jobinfo attribute:', job);
        }
      } catch (error) {
        console.error('Error parsing data-jobinfo:', error, job);
      }
    }

    job.style.display = jobMatchFound ? 'flex' : 'none';
  });
}

export function searchJobs() {
    const searchQuery = document.getElementById('job-search').value.toLowerCase();
    const searchTerms = searchQuery.split(/\s+/).filter(term => term.length > 0);
    let allJobs;
    
    if (billingJobsActive) {
      allJobs = document.querySelectorAll('.job-item.complete-job');
    } else if (closedJobsActive) {
      allJobs = document.querySelectorAll('.job-item.closed-job');
    } else {
      allJobs = document.querySelectorAll('.job-item');
    }
  
    const allJobsArray = Array.from(allJobs);
  
    document.querySelectorAll('.job-item').forEach(job => {
      job.style.display = 'none';
    });

    allJobsArray.forEach(job => {

      if (job.classList.contains('filtered')) {
        return;
      }

      let jobMatchFound = false;

      if (searchTerms.length === 0) {
        jobMatchFound = true;
      } else {

        try {
          const jobData = JSON.parse(job.getAttribute('data-jobinfo'));
          if (jobData) {
            delete jobData.Notes;
            jobMatchFound = searchTerms.every(term =>
              JSON.stringify(jobData).toLowerCase().includes(term)
            );
          } else {
            console.error('Missing or invalid data-jobinfo attribute:', job);
          }
        } catch (error) {
          console.error('Error parsing data-jobinfo:', error, job);
        }
      }

      // '' (not 'flex'): #jobList now mixes plain flex .job-item rows
      // elsewhere with the new grid-based .job-item.op-table-row rows —
      // confirmed live that hardcoding 'flex' here was clobbering the grid
      // layout on every search/filter pass. '' defers to each row's own
      // stylesheet display value, which is correct either way.
      job.style.display = jobMatchFound ? '' : 'none';
    });
}



function buildSearchString(job) {
  let out = '';

  for (const key in job) {
    if (!Object.prototype.hasOwnProperty.call(job, key)) continue;
    if (key === 'Notes') continue;

    const v = job[key];

    if (v == null) continue;

    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
      out += ' ' + String(v);
    } else if (typeof v === 'object') {
      // shallow flatten common nested objects (avoids expensive JSON.stringify)
      for (const k2 in v) {
        if (!Object.prototype.hasOwnProperty.call(v, k2)) continue;
        const v2 = v[k2];
        if (v2 == null) continue;
        if (typeof v2 === 'string' || typeof v2 === 'number' || typeof v2 === 'boolean') {
          out += ' ' + String(v2);
        }
      }
    }
  }

  return out.toLowerCase();
}

export async function searchClosedJobsIndexedDB() {
  const seq = ++closedDrawSeq;
  const searchQuery = document.getElementById('closed-search').value.toLowerCase();
  const searchTerms = searchQuery.split(/\s+/).filter(term => term.length > 0);

  try {
    const db = await getDB();
    const transaction = db.transaction(['closedJobs'], 'readonly');
    const objectStore = transaction.objectStore('closedJobs');
    const jobListDiv = document.getElementById('closedJobList');
    const filteredJobs = [];

    await new Promise((resolve) => {
      objectStore.openCursor().onsuccess = (event) => {
        const cursor = event.target.result;
        if (!cursor) return resolve();

        const job = cursor.value;
        if (job) {
          const haystack = buildSearchString(job);
          const isMatch = searchTerms.every(term => haystack.includes(term));
          if (isMatch) filteredJobs.push(job);
        }

        cursor.continue();
      };
    });

    // Newest first, the same order as the unfiltered list (lazyLoadJobs).
    const when = (job) => { const t = new Date(job.Start_Date || job.Request_Date || '').getTime(); return Number.isFinite(t) ? t : 0; };
    filteredJobs.sort((a, b) => when(b) - when(a));

    if (seq !== closedDrawSeq) return;
    jobListDiv.innerHTML = '';
    await shell.renderJobsInChunks(filteredJobs, jobListDiv, 'closed', () => seq !== closedDrawSeq);
  } catch (error) {
    console.error("Error searching jobs in IndexedDB:", error);
  }
}


let closedSearchTimer;

async function searchClosedJobs() {
  clearTimeout(closedSearchTimer);

  closedSearchTimer = setTimeout(async () => {
    const searchQuery = document.getElementById('closed-search').value.toLowerCase();

    if (searchQuery.trim() === '') {
      await closedJobList();
    } else {
      await searchClosedJobsIndexedDB();
    }
  }, 250);
}


function toggleButton(button) {

  selectedButtons[button.textContent] = !selectedButtons[button.textContent];
  button.classList.toggle('selected');
  const selected = document.querySelectorAll('.selected');

  searchJobs();

}

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.filter-button');
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      toggleButton(this);
    });
  });
});

// Each Closed-list draw (full list or search) takes a number; one that a newer draw overtook while
// it was loading stops before touching the list, so two overlapping draws can't both append rows.
let closedDrawSeq = 0;

export async function closedJobList() {
  const seq = ++closedDrawSeq;
  try {
    const db = await getDB();
    const tx = db.transaction(['closedJobs'], 'readonly');
    const jobStore = tx.objectStore('closedJobs');

    const jobs = await new Promise((resolve, reject) => {
      const req = jobStore.getAll();
      req.onerror = () => reject(req.error);
      req.onsuccess = () => resolve(req.result || []);
    });

    const jobsArray = jobs.filter(job => job && job.Status === 'Closed');

    const getEffectiveDate = (job) => {
      const d = job.Start_Date || job.Request_Date || '';
      const t = new Date(d).getTime();
      return Number.isFinite(t) ? t : 0;
    };

    jobsArray.sort((a, b) => getEffectiveDate(a) - getEffectiveDate(b));

    const closedJobListDiv = document.getElementById('closedJobList');

    const [receivingData, customerRecords] = await Promise.all([
      shell.loadOutstandingJobPartOrders(),
      shell.fetchDataFromStore('customerData').catch(() => [])
    ]);
    shell.latestReceivingData = receivingData;
    shell.latestCustomerDataById = new Map(customerRecords.map(c => [c.id, c]));

    if (seq !== closedDrawSeq) return;
    closedJobListDiv.innerHTML = '';
    await shell.lazyLoadJobs(jobsArray, closedJobListDiv, 'closed');

    // Avoid stacking the same listener multiple times
    if (closedJobListDiv.dataset.clickBound !== "1") {
      closedJobListDiv.dataset.clickBound = "1";
      closedJobListDiv.addEventListener('click', throttle(shell.opCheck, 200));
    }
  } catch (error) {
    console.error("Error fetching job data from IndexedDB:", error);
  }
}

// "This Week" tab (switchView('schedule')) — previously just showed the date range with nothing
// underneath it: switchView() never called a populate function, and updateWeekView() (which looks
// like it should be the one) actually targets #week-container, which belongs to the separate
// Scheduler modal (index.html), not this tab. Built fresh here, reusing the same shared row
// builder (createOperationRow()) and priming (latestReceivingData/latestCustomerDataById) the
// Operations/Closed tabs already use, so a scheduled op looks identical everywhere it appears.
